module.exports = __webpack_public_path__ + "img/ICON_Tu-centro-de-ayuda.7eb0769d.svg";